document.addEventListener('DOMContentLoaded', function() {
  const bottomCart = document.getElementById('bottom-cart');
  const cartItemsList = document.getElementById('bottom-cart-items');
  const cartTotal = document.getElementById('bottom-cart-total');
  const AddTocart = document.querySelector('.add-to-cart');
  const mainContainer = document.querySelector('.catering-data-items');
  const emptyCart = document.getElementById('empty-cart');

  // Helper to format money
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    return '$' + (cents / 100).toFixed(2);
  }

  // Load existing cart quantities into listing inputs
  function loadCartQuantities() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.product-card').forEach(card => {
          const variantId = parseInt(card.dataset.variantId);
          const cartItem = cart.items.find(item => item.variant_id === variantId);
          if (cartItem) {
            if (card.querySelector('.qty-input')) card.querySelector('.qty-input').value = cartItem.quantity;
          }
        });
        updateMiniCartDisplay(cart);
      });
  }

  // Handle plus/minus click inside product cards
  document.body.addEventListener('click', function(e) {
    if (!e.target.classList.contains('qty-plus') &&
        !e.target.classList.contains('qty-minus')) {
      return;
    }

    const productCard = e.target.closest('.product-card');
    if (!productCard) return;

    const qtyInput = productCard.querySelector('.qty-input');
    if (!qtyInput) return;

    let qty = parseInt(qtyInput.value) || 0;

    if (e.target.classList.contains('qty-plus')) {
      qty++;
    } else if (e.target.classList.contains('qty-minus')) {
      qty = Math.max(0, qty - 1); // allow 0 to remove
    }

    qtyInput.value = qty;
    updateShopifyCart(productCard.dataset.variantId, qty);
  });

  // Handle Add To Cart click
if (AddTocart) {
  AddTocart.addEventListener('click', function (e) {
    const productCard = e.target.closest('.product-card');
    const variantId = e.target.dataset.variantId;
    if (!productCard) return;

    let hasQty = false;

   // --- Sandwich selections ---
let sandwichSelections = [];
productCard.querySelectorAll('.sand-data-info-quantity').forEach(row => {
  const name = row.querySelector('h2')?.textContent.trim();
  const qty = parseInt(row.querySelector('.cat-qty-input')?.value || 0, 10);
  if (qty > 0) {
    hasQty = true;
    sandwichSelections.push(
      `<div class="name-qty-selection"><h2>${name}</h2><p>(${qty})</p></div>`
    );
  }
});

// --- Muffin selections ---
let muffinSelections = [];
productCard.querySelectorAll('.muffin-data-info-quantity').forEach(row => {
  const name = row.querySelector('h2')?.textContent.trim();
  const qty = parseInt(row.querySelector('.cat-qty-input')?.value || 0, 10);
  if (qty > 0) {
    hasQty = true;
    muffinSelections.push(
      `<div class="name-qty-selection"><h2>${name}</h2><p>(${qty})</p></div>`
    );
  }
});

// --- Build final HTML (same as before) ---
let selectionsHTML = '';
if (sandwichSelections.length > 0) {
  const sandwichHeading =
    productCard.querySelector('.catering-sandwich h2')?.textContent.trim() || 'Sandwiches';
  selectionsHTML += `<div class="section-group"><h3 class="main-selection-head">${sandwichHeading}</h3>${sandwichSelections.join('')}</div>`;
}
if (muffinSelections.length > 0) {
  const muffinHeading =
    productCard.querySelector('.catering-muffin h2')?.textContent.trim() || 'Muffins';
  selectionsHTML += `<div class="section-group"><h3 class="main-selection-head">${muffinHeading}</h3>${muffinSelections.join('')}</div>`;
}

// --- Build plain text (human readable) ---
let selectionsPlain = '';
if (sandwichSelections.length > 0) {
  const sandwichHeading =
    productCard.querySelector('.catering-sandwich h2')?.textContent.trim() || 'Sandwiches';
  selectionsPlain += sandwichHeading + '\n';
  sandwichSelections.forEach(html => {
    const name = html.match(/<h2>(.*?)<\/h2>/)[1];
    const qty = html.match(/<p>(.*?)<\/p>/)[1];
    selectionsPlain += `- ${name}: ${qty}\n`;
  });
  selectionsPlain += '\n';
}
if (muffinSelections.length > 0) {
  const muffinHeading =
    productCard.querySelector('.catering-muffin h2')?.textContent.trim() || 'Muffins';
  selectionsPlain += muffinHeading + '\n';
  muffinSelections.forEach(html => {
    const name = html.match(/<h2>(.*?)<\/h2>/)[1];
    const qty = html.match(/<p>(.*?)<\/p>/)[1];
    selectionsPlain += `- ${name}: ${qty}\n`;
  });
  selectionsPlain += '\n';
}



    // Only add to cart if at least one qty > 0
    if (hasQty) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
  "Selections": selectionsPlain,
  "_key_point": productCard.dataset.keyPoint || '',
  "_variant_title": productCard.dataset.selectedVariantTitle || ''
}

        })
      })
        .then(() => fetch('/cart.js'))
  .then(res => res.json())
  .then(cart => {
    // Attach the HTML version temporarily so updateMiniCartDisplay can use it
    cart.items.forEach(item => {
      if (item.properties.Selections === selectionsPlain) {
        item.selectionsHTML = selectionsHTML; // custom property, only in frontend
      }
    });
    updateMiniCartDisplay(cart);
 });

    } else {
      let qty = 1;
      updateShopifyCart(productCard.dataset.variantId, qty);
    }

    // Button feedback
    const originalText = AddTocart.textContent;
    AddTocart.textContent = 'Added!';
    AddTocart.disabled = true;

    setTimeout(() => {
      AddTocart.textContent = originalText;
      AddTocart.disabled = false;
      // ✅ scroll to #bottom-cart
  const bottomCart = document.getElementById('bottom-cart');
  if (bottomCart) {
    bottomCart.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
    }, 2000);
  });
}

// Convert plain text back into HTML selections
function buildSelectionsHTML(selectionsPlain) {
  if (!selectionsPlain) return '';

  let html = '';
  let currentSection = '';

  selectionsPlain.split('\n').forEach(line => {
    line = line.trim();
    if (!line) return;

    if (!line.startsWith('-')) {
      // Section heading
      if (currentSection) html += '</div>'; 
      currentSection = line;
      html += `<div class="section-group"><h3 class="main-selection-head">${line}</h3>`;
    } else {
      // Item line "- Name: Qty"
      const parts = line.replace(/^- /, '').split(':');
      const name = parts[0].trim();
      const qty = parts[1]?.trim() || 0;
      html += `<div class="name-qty-selection"><h2>${name}</h2><p>${qty}</p></div>`;
    }
  });

  if (currentSection) html += '</div>';
  return html;
}


// Delegate click on .header-selection or its .open-close
document.body.addEventListener('click', function (e) {
  const header = e.target.closest('.header-selection'); // check if click was inside header
  if (!header) return;

  const selectionsDiv = header.nextElementSibling; // the .selections div
  if (!selectionsDiv) return;

  // Toggle visibility
  const isHidden = selectionsDiv.style.display === 'none' || !selectionsDiv.style.display;
  selectionsDiv.style.display = isHidden ? 'block' : 'none';

  // Always update the .open-close span
  const icon = header.querySelector('.open-close');
if (icon) {
  icon.innerHTML = isHidden
    ? `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3 10H17" stroke="#262124" stroke-linecap="square"/>
       </svg>`
    : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 3V17M3 10H17" stroke="#262124" stroke-linecap="square"/>
       </svg>`;
}

});


  // Handle plus/minus inside mini-cart
  document.body.addEventListener('click', function(e) {
    const cartItem = e.target.closest('.mini-cart-item');
    if (!cartItem) return;

    const qtyInput = cartItem.querySelector('.cart-qty-input');
    let qty = parseInt(qtyInput.value);

    if (e.target.classList.contains('cart-qty-plus')) {
      qty++;
    } else if (e.target.classList.contains('cart-qty-minus')) {
      qty = Math.max(0, qty - 1);
    } else {
      return;
    }

    qtyInput.value = qty;
    updateShopifyCart(cartItem.dataset.variantId, qty, true);

  });

  // Update Shopify cart and refresh bottom cart
  function updateShopifyCart(variantId, quantity, syncListing = false) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: quantity } })
    })
    .then(res => res.json())
    .then(cart => {
      updateMiniCartDisplay(cart);
      if (syncListing) {
        const productCard = document.querySelector(`.product-card[data-variant-id="${variantId}"]`);
        if (productCard) {
          const qtyInput = productCard.querySelector('.qty-input');
          if (qtyInput) {
            qtyInput.value = quantity;
          }
        }
      }
    });
  }

  
// Update bottom mini-cart display
function updateMiniCartDisplay(cart) {
  
  cartItemsList.innerHTML = '';
  cart.items.forEach(item => {
    const productCard = document.querySelector(`.product-card[data-variant-id="${item.variant_id}"]`);
   

let keyPoint = '';
let variantTitle = '';

// ✅ 1. BEST: stored on cart item (new items)
if (item.properties?._key_point) {
  keyPoint = item.properties._key_point;
}

if (item.properties?._variant_title) {
  variantTitle = item.properties._variant_title;
}

// ✅ 2. FALLBACK: old items (safe, no DOM)
if (!keyPoint) {
  keyPoint = item.product_title;
  variantTitle =
    item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title
      : '';
}

// ❌ 3. DO NOT override with productCard
// (remove this completely)
// if (productCard) {
//   keyPoint = productCard.dataset.keyPoint || '';
//   variantTitle = productCard.dataset.selectedVariantTitle || '';
// }



    //alert(keyPoint);

   // ✅ Prefer frontend HTML (when item was just added)
    // ✅ Otherwise rebuild HTML from plain text
    let selections = '';
    let ItemsTitle = item.product_title;
    // If product title contains "People"
       if (ItemsTitle.includes("People")) {
            ItemsTitle = `Catering Package — ${ItemsTitle}`;
         }else{
          ItemsTitle = item.product_title;
         }
    if (item.selectionsHTML) {
      selections = `<div class="main-slelection">
      <div class="header-selection">Your selections <span class="open-close"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 3V17M3 10H17" stroke="#262124" stroke-linecap="square"/>
</svg></span></div>
      <div class="selections"  style="display:none;">${item.selectionsHTML}</div>
      </div>`;
    } else if (item.properties?.Selections) {
      const rebuiltHTML = buildSelectionsHTML(item.properties.Selections);
      selections = `<div class="main-slelection">
      <div class="header-selection">Your selections <span class="open-close"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 3V17M3 10H17" stroke="#262124" stroke-linecap="square"/>
</svg></span></div>
      <div class="selections"  style="display:none;">${rebuiltHTML}</div></div>`;
    }




    const li = document.createElement('li');
    li.innerHTML = `
      <div class="mini-cart-item" data-variant-id="${item.variant_id}">
        <h2>${ItemsTitle}</h2>
       ${keyPoint ? `
  <div class="key-point">
    ${keyPoint}${variantTitle ? ` - ${variantTitle}` : ''}
  </div>
` : ''}
        ${selections}
        <div class="quantity-price-catering"> 
          <div class="quantity mini-cart-qty">
            <button class="quantity__button qty-minus cart-qty-minus" name="minus" type="button">−</button>
            <input type="number" class="quantity__input cart-qty-input" value="${item.quantity}" min="0">
            <button class="quantity__button qty-plus cart-qty-plus" name="plus" type="button">+</button>
          </div>
          <span class="cart-item-total">${formatMoney(item.line_price)}</span>
        </div>
      </div>
    `;
    cartItemsList.appendChild(li);
  });

  cartTotal.textContent = formatMoney(cart.total_price);
  bottomCart.style.display = cart.items.length > 0 ? 'block' : 'none';
  emptyCart.style.display = cart.items.length > 0 ? 'none' : 'block';
}

document.body.addEventListener('click', function (e) {
  const item = e.target.closest('.variant-item');
  if (!item) return;

  const group = item.closest('.variant-group');
  const productCard = item.closest('.product-card');
  if (!group || !productCard) return;

  const optionIndex = parseInt(group.dataset.optionIndex);
  const value = item.dataset.value;

  // Update selected label
  group.querySelector('.variant-label').textContent = value;

  // Update UI selected state
  group.querySelectorAll('.variant-item').forEach(el => {
    el.classList.remove('is-selected');
    el.setAttribute('aria-selected', 'false');
  });
  item.classList.add('is-selected');
  item.setAttribute('aria-selected', 'true');

  // --- FIND MATCHING VARIANT ---
  const variants = JSON.parse(productCard.dataset.variants);
  const selectedOptions = [];

  productCard.querySelectorAll('.variant-group').forEach(group => {
    selectedOptions.push(
      group.querySelector('.variant-label').textContent.trim()
    );
  });

  const matchedVariant = variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!matchedVariant) return;

  // 🔥 UPDATE product-card DATA
  productCard.dataset.variantId = matchedVariant.id;

  // Variant-level key point (fallback to product)
  const variantKeyPoint =
    matchedVariant.metafields?.custom?.key_point ||
    productCard.dataset.keyPoint;

  productCard.dataset.keyPoint = variantKeyPoint || '';

  // Store selected variant title
  productCard.dataset.selectedVariantTitle = matchedVariant.title;
});

  // Initial load
  loadCartQuantities();
});
